import { render } from "./AdminActionLog.vue?vue&type=template&id=1d536865"
const script = {}

import "./AdminActionLog.vue?vue&type=style&index=0&id=1d536865&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__